module.exports = __webpack_public_path__ + "assets/img/Rail Corridor.1ac15028.jpg";